import { getCookie, setCookie } from "utils"

import type { StorageStrategy } from "./StorageStrategy"

/**
 * Storage strategy backed by browser cookies.
 * Delegates to the existing `getCookie` / `setCookie` utilities from `utils/cookies.ts`.
 *
 * Cookies are set with `Path=/; SameSite=Strict` (and `Secure` in production).
 * Empty cookie values are treated as missing (returns `undefined`).
 */
class CookieStorageStrategy implements StorageStrategy {
  getItem(key: string): string | undefined {
    return getCookie(key) || undefined
  }

  setItem(key: string, value: string): void {
    setCookie(key, value)
  }

  deleteItem(key: string): void {
    setCookie(key, undefined)
  }
}

// Exported as a module-level singleton since it is stateless.
export const cookieStorageStrategy = new CookieStorageStrategy()
